type CloudKey = "classic-deck" | "last-cod-card" | "reset-version" | "current-deck-holder";

export async function getCloudValue(key: CloudKey) {
	return new Promise<string | null>((resolve, reject) => {
		window.Telegram.WebApp.CloudStorage.getItem(key, (error, result) => {
			if (error) {
				reject(error);

				return;
			}

			resolve(result ?? null);
		});
	});
}
export async function getCloudValues(keys: CloudKey[]) {
	return new Promise<Record<string, string> | null>((resolve, reject) => {
		window.Telegram.WebApp.CloudStorage.getItems(keys, (error, result) => {
			if (error) {
				reject(error);

				return;
			}

			resolve(result ?? null);
		});
	});
}
export async function setCloudValue(key: CloudKey, value: string) {
	return new Promise<true>((resolve, reject) => {
		if (value.length > 4096) reject("Value is too long!");

		window.Telegram.WebApp.CloudStorage.setItem(
			key,
			value,
			(error, success) => {
				if (error || !success) {
					reject(error);

					return;
				}

				resolve(true);
			},
		);
	});
}
